import React from "react";
import "./Partnership.css";

export default function Partnership() {
  return (
    <section className="partnership">
      <div className="partnership-text">
        <h2>Un partenaire proche de vous</h2>
        <p>
          Chez <span style={{ color: '#a020f0', fontWeight: 'bold' }}>NEXUS SOLUTIONS</span>, nous croyons que les relations de confiance et
          la proximité avec nos clients sont essentielles pour atteindre des
          résultats durables. Nous accompagnons chaque étape de vos projets en
          apportant notre expertise et en privilégiant la transparence.
        </p>
      </div>
      <div className="partnership-image">
        <img src={require("../../assets/images/Partenaire.png")} alt="Partenaire proche de vous" style={{ maxWidth: '420px', width: '100%', borderRadius: '14px' }} />
      </div>
    </section>
  );
}
